var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ent-sign" },
    [
      _c("h1", { staticClass: "com-title com-ht" }, [
        _c("i"),
        _vm._v(_vm._s(_vm.title))
      ]),
      _c(
        "div",
        { staticClass: "box-wrap" },
        [
          _vm._l(_vm.chapterList, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                class: [
                  "temone",
                  { active: _vm.sealTabItem.signId === item.signId && false }
                ]
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "t-box",
                    on: {
                      click: function($event) {
                        return _vm.sealTabClickFn(item)
                      }
                    }
                  },
                  [
                    item.defaultChapter && item.defaultChapter === 1
                      ? _c("img", {
                          staticClass: "mr-label",
                          attrs: { src: "/images/web/icon-default.png" }
                        })
                      : _vm._e(),
                    _c("img", {
                      staticClass: "y-img",
                      attrs: { src: item.signUrl, title: item.signName }
                    }),
                    _c("div", { staticClass: "msk" }, [
                      _c(
                        "div",
                        {
                          staticClass: "list_one left-linear",
                          staticStyle: { "border-bottom": "1px solid" }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: "设为默认",
                                placement: "left"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "el-icon-price-tag setting_icon",
                                attrs: { title: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.setDefaultSeal(item.signId)
                                  }
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "list_one top-linear",
                          staticStyle: { "border-left": "1px solid" }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: "修改",
                                placement: "right"
                              }
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "el-icon-edit-outline setting_icon",
                                staticStyle: { "margin-top": "1px" },
                                attrs: { title: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.editSign(item)
                                  }
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "list_one bottom-linear",
                          staticStyle: { "border-right": "1px solid" }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "light",
                                content: "删除",
                                placement: "left"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "el-icon-delete setting_icon",
                                attrs: { title: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.delChapter(item.signId)
                                  }
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      !_vm.basisVersion
                        ? _c(
                            "div",
                            {
                              staticClass: "list_one right-linear",
                              staticStyle: { "border-top": "1px solid" }
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    content: "打开后该印章可授权给成员",
                                    placement: "right"
                                  }
                                },
                                [
                                  _c("switch-button", {
                                    staticStyle: { margin: "auto" },
                                    attrs: { object: item },
                                    on: { confirmFn: _vm.allowToUse },
                                    model: {
                                      value: item.corpSealId,
                                      callback: function($$v) {
                                        _vm.$set(item, "corpSealId", $$v)
                                      },
                                      expression: "item.corpSealId"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        return _vm.sealTabClickFn(item)
                      }
                    }
                  },
                  [
                    _c("p", { attrs: { title: item.signName } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.signName) +
                          "\n          "
                      )
                    ]),
                    _c("p", { attrs: { title: "ID:" + item.signId } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s("ID:" + item.signId) +
                          "\n          "
                      )
                    ])
                  ]
                ),
                !_vm.basisVersion
                  ? _c("div", { staticClass: "process_auth_btn" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.corpSealId,
                              expression: "item.corpSealId"
                            }
                          ],
                          staticClass: "approve_process"
                        },
                        [
                          _c(
                            "div",
                            {
                              class: [
                                "approve_edit",
                                "margi_bottom",
                                {
                                  not_active: !_vm.authSealList.includes(
                                    item.corpSealId
                                  )
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.emitAuthListFn(item)
                                }
                              }
                            },
                            [_vm._v("印章授权")]
                          )
                        ]
                      ),
                      item.corpSealId
                        ? _c("div", { staticClass: "approve_process" }, [
                            _vm.processTextFn(item)
                              ? _c("div", { staticClass: "approve_item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info_box" },
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "top-start",
                                            trigger: "click"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flow_detail" },
                                            [
                                              _c(
                                                "p",
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        !_vm.isInDingTalk
                                                          ? item.flowDetail &&
                                                              item.flowDetail
                                                                .flowName
                                                          : _vm.isInDingTalk &&
                                                            item.dingTalkFlow
                                                          ? item.dingTalkFlow
                                                              .flowName
                                                          : ""
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                  _vm.processTextFn(item)
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "10px"
                                                          },
                                                          attrs: {
                                                            type: "primary",
                                                            size: "mini"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.delShenPi(
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "取消审批\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    height: "125px",
                                                    "overflow-y": "scroll"
                                                  }
                                                },
                                                [
                                                  _c("approval-process", {
                                                    attrs: {
                                                      flowInfo: _vm.computeInfo(
                                                        item
                                                      ),
                                                      orderFlag:
                                                        item.flowDetail &&
                                                        !_vm.isInDingTalk
                                                          ? item.flowDetail
                                                              .orderFlag
                                                          : item.dingTalkFlow
                                                              .flowType
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "approve_info",
                                              attrs: { slot: "reference" },
                                              slot: "reference"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  !_vm.isInDingTalk
                                                    ? item.flowDetail &&
                                                        item.flowDetail.flowName
                                                    : item.dingTalkFlow
                                                    ? item.dingTalkFlow.flowName
                                                    : ""
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _c("div", { staticStyle: { height: "54px" } }, [
                            _vm._v(" 打开印章授权开关后，才可设置授权及流程")
                          ])
                    ])
                  : _vm._e()
              ]
            )
          }),
          _c("el-popover", { attrs: { placement: "right", width: "200" } }, [
            _c(
              "div",
              { staticClass: "popover-style" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: { click: _vm.openFileUploadDialog }
                  },
                  [_vm._v("本地上传\n          ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.makeOnline(false)
                      }
                    }
                  },
                  [_vm._v("在线制作")]
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "temone add",
                attrs: { slot: "reference" },
                slot: "reference"
              },
              [_c("span", { staticClass: "el-icon-plus" })]
            )
          ])
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-child",
          attrs: {
            title: "签署配置",
            visible: _vm.dialogVisibleChild,
            "close-on-click-modal": false,
            width: "560px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisibleChild = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "child-list" },
            [
              _vm.chapterChildList.length
                ? _vm._l(_vm.chapterChildList, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "text-center list-item" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: item.ifUse,
                              callback: function($$v) {
                                _vm.$set(item, "ifUse", $$v)
                              },
                              expression: "item.ifUse"
                            }
                          },
                          [_vm._v(_vm._s(item.sourceTag))]
                        )
                      ],
                      1
                    )
                  })
                : _vm._e()
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "text-center footer-btn",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "success", size: "small" },
                  on: { click: _vm.queryChangeChildChapter }
                },
                [_vm._v("确定\n        ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisibleChild = false
                    }
                  }
                },
                [_vm._v("取消\n        ")]
              )
            ],
            1
          )
        ]
      ),
      _c("goto-auth", {
        attrs: { authDialog: _vm.authDialog },
        on: {
          "update:authDialog": function($event) {
            _vm.authDialog = $event
          },
          "update:auth-dialog": function($event) {
            _vm.authDialog = $event
          }
        }
      }),
      _c("sign-on-line", {
        attrs: { onLineVise: _vm.onLineVise, signInfo: _vm.curretSignInfo },
        on: {
          viseControl: function($event) {
            _vm.onLineVise = !_vm.onLineVise
          },
          getChapterList: _vm.getChapterList
        }
      }),
      _vm.isAddSign
        ? _c("create-local-seal", {
            attrs: { userType: 1, newSign: _vm.newSign },
            on: { signCreated: _vm.signCreated }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "关联审批",
            visible: _vm.authDialogVisible,
            width: "45%"
          },
          on: {
            "update:visible": function($event) {
              _vm.authDialogVisible = $event
            }
          }
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                "font-size": "14px",
                "font-weight": "400",
                "line-height": "24px",
                color: "#290202",
                "margin-bottom": "10px"
              }
            },
            [
              _c("i", { staticClass: "warn-img el-icon-warning" }),
              _vm._v(
                "\n        将印章与用印审批流程关联，使用印章签署文件时需先进行审批\n      "
              )
            ]
          ),
          _c(
            "ul",
            { staticClass: "liuChengUl" },
            [
              _c(
                "li",
                {
                  key: "9999",
                  style:
                    _vm.choosedProcess && _vm.choosedProcess.flowId == "No0"
                      ? "background:#f1f1f1"
                      : "",
                  on: {
                    click: function($event) {
                      _vm.choosedProcess = { flowId: "No0" }
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/images/icon/icon-liucheng.jpg"),
                      alt: ""
                    }
                  }),
                  _vm._v("\n          无需审批\n        ")
                ]
              ),
              _vm._l(_vm.processList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    style:
                      _vm.choosedProcess &&
                      _vm.choosedProcess.flowId == item.flowId
                        ? "background:#f1f1f1"
                        : "",
                    on: {
                      click: function($event) {
                        _vm.choosedProcess = item
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/icon/icon-liucheng.jpg"),
                        alt: ""
                      }
                    }),
                    _vm._v(
                      "\n          " + _vm._s(item.flowName) + "\n          "
                    ),
                    !_vm.isInDingTalk
                      ? _c("span", { staticStyle: { "font-size": "12px" } }, [
                          _vm._v(
                            "（" +
                              _vm._s(
                                (item.orderFlag ? "顺序审批：" : "会审：") +
                                  item.allPartName
                              ) +
                              "）"
                          )
                        ])
                      : _c(
                          "span",
                          { staticStyle: { "font-size": "12px" } },
                          [
                            _vm._v(
                              "\n            （" +
                                _vm._s(
                                  item.flowType === 1 ? "顺序审批：" : "会审："
                                ) +
                                "）\n            "
                            ),
                            item.flowType === 1
                              ? _vm._l(item.nodes, function(node, i) {
                                  return _c("span", { key: i }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(node.userApproveUsers[0].name) +
                                        "\n                "
                                    ),
                                    i < item.nodes.length - 1
                                      ? _c("span", [_vm._v(_vm._s("->"))])
                                      : _vm._e()
                                  ])
                                })
                              : _vm._l(item.nodes[0].userApproveUsers, function(
                                  node,
                                  i
                                ) {
                                  return _c("span", { key: i }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(node.name) +
                                        "\n                "
                                    ),
                                    i <
                                    item.nodes[0].userApproveUsers.length - 1
                                      ? _c("span", [_vm._v("、")])
                                      : _vm._e()
                                  ])
                                })
                          ],
                          2
                        )
                  ]
                )
              })
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.chooseProcess()
                    }
                  }
                },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.authDialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "印章授权",
            visible: _vm.SealAuth.visi,
            width: "80%"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.SealAuth, "visi", $event)
            }
          }
        },
        [
          _c("Grant", {
            attrs: { sealInfo: _vm.SealAuth.sealInfo },
            on: {
              getAuthSealList: _vm.getAuthSealList,
              editApproveFn: _vm.editApproveFn
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fbd7e90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fbd7e90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/console/seal/mySign.vue
// module id = OmTp
// module chunks = 7 30